<template>
  <div class="page-container">
    <el-card>
      <template #header>
        <div class="card-header">
          <span>{{ $t('schedule.title') }}</span>
        </div>
      </template>

      <el-calendar v-model="currentDate">
        <template #date-cell="{ data }">
          <div class="calendar-cell">
            <span>{{ data.day.split('-').slice(2).join('-') }}</span>
            <div v-if="hasSchedule(data.day)" class="schedule-dot"></div>
          </div>
        </template>
      </el-calendar>

      <el-divider />

      <el-table :data="scheduleStore.schedules" v-loading="loading" stripe>
        <el-table-column prop="date" :label="$t('schedule.date')" />
        <el-table-column prop="startTime" :label="$t('schedule.startTime')" />
        <el-table-column prop="endTime" :label="$t('schedule.endTime')" />
        <el-table-column prop="teacherName" :label="$t('schedule.teacher')" />
        <el-table-column prop="horseName" :label="$t('schedule.horse')" />
        <el-table-column prop="status" :label="$t('schedule.status')">
          <template #default="{ row }">
            <el-tag :type="row.status === 'available' ? 'success' : 'info'">
              {{ row.status === 'available' ? $t('schedule.available') : $t('schedule.booked') }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useScheduleStore } from '@/stores/schedule'

const router = useRouter()
const { t } = useI18n()
const scheduleStore = useScheduleStore()

const loading = ref(false)
const currentDate = ref(new Date())
const scheduleDates = ref([])

const fetchData = async () => {
  loading.value = true
  await scheduleStore.fetchSchedules()
  scheduleDates.value = scheduleStore.schedules.map(s => s.date)
  loading.value = false
}

const hasSchedule = (day) => {
  return scheduleDates.value.includes(day)
}

onMounted(fetchData)
</script>

<style lang="scss" scoped>
.calendar-cell {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.schedule-dot {
  width: 6px;
  height: 6px;
  background-color: #409EFF;
  border-radius: 50%;
  margin-top: 4px;
}
</style>
